import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[color:var(--fis-ink)] text-white"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <div className="flex items-center gap-4 mb-8">
              <img
                src="/brand/fis-logo.png"
                alt="FIS logo"
                className="w-14 h-14 object-contain bg-white p-1"
              />
              <div className="font-mono-label text-white/60">
                Frontline Intelligence System
              </div>
            </div>
            <h3 className="font-display text-5xl md:text-8xl leading-none">
              Frontline
              <br />
              <span className="text-[color:var(--fis-accent-soft)]">
                Intelligence.
              </span>
            </h3>
            <p className="mt-8 text-white/60 max-w-md">
              Operating partner for ambitious teams. Recruitment · Software ·
              AI · Web.
            </p>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 gap-8 text-sm">
            <div>
              <div className="font-mono-label text-white/50">Navigate</div>
              <ul className="mt-4 space-y-2">
                <li><a href="#services" className="hover:text-[color:var(--fis-accent-soft)]">Services</a></li>
                <li><a href="#process" className="hover:text-[color:var(--fis-accent-soft)]">Process</a></li>
                <li><a href="#about" className="hover:text-[color:var(--fis-accent-soft)]">About</a></li>
                <li><a href="#careers" className="hover:text-[color:var(--fis-accent-soft)]">Careers</a></li>
                <li><a href="#contact" className="hover:text-[color:var(--fis-accent-soft)]">Contact</a></li>
              </ul>
            </div>
            <div>
              <div className="font-mono-label text-white/50">Contact</div>
              <ul className="mt-4 space-y-2">
                <li>
                  <a href="mailto:contact@frontlineintelligencesystem.com" className="hover:text-[color:var(--fis-accent-soft)]">
                    contact@frontlineintelligencesystem.com
                  </a>
                </li>
                <li>
                  <a href="tel:+918470915123" className="hover:text-[color:var(--fis-accent-soft)]" data-testid="footer-phone-in">
                    +91 84709 15123 <span className="text-white/40 font-mono-label">IN</span>
                  </a>
                </li>
                <li>
                  <a href="tel:+16093059720" className="hover:text-[color:var(--fis-accent-soft)]" data-testid="footer-phone-us">
                    +1 609-305-9720 <span className="text-white/40 font-mono-label">US</span>
                  </a>
                </li>
                <li className="text-white/60">C-27, EFC, 2nd Floor,<br />Trapezoid IT Park, Sector 62,<br />Noida, UP 201301</li>
                <li>
                  <Link to="/admin" className="hover:text-[color:var(--fis-accent-soft)]" data-testid="footer-admin-link">
                    Team login
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Frontline Intelligence System. All rights reserved.</div>
          <div className="font-mono-label">FIS · v1.0</div>
        </div>
      </div>
    </footer>
  );
}
